var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, OnDestroy, ElementRef, TemplateRef, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppinfoService } from './../../../services//appinfo.service';
import { CommonFunctionService } from './../../../services/common-function.service';
import { CommonModalService } from 'app/services/common-modal.service';
import { ContentJobsService } from './../content-jobs.service';
import { FieldMappingService } from './../../../services/field-mapping.service';
import { UserService } from './../../../services/user.service';
import { CommonTableService } from 'app/services/common-table.service';
import { ModalCheckMappingComponent } from '../modal-check-mapping/modal-check-mapping.component';
import { IntegratorService } from 'app/services/integrator.service';
import { CommonDatagridComponent } from 'app/components/common-datagrid/common-datagrid.component';
import { AttrIndexService } from 'app/services/attr-index.service';
import { AdminService } from 'app/services/admin.service';
var JobsFieldMappingComponent = /** @class */ (function () {
    function JobsFieldMappingComponent(router, elemRef, adminService, appinfoService, attrIndexService, commonFuncService, tableService, modalService, jobsService, fieldMappingService, integratorService, userService, toastrService) {
        this.router = router;
        this.elemRef = elemRef;
        this.adminService = adminService;
        this.appinfoService = appinfoService;
        this.attrIndexService = attrIndexService;
        this.commonFuncService = commonFuncService;
        this.tableService = tableService;
        this.modalService = modalService;
        this.jobsService = jobsService;
        this.fieldMappingService = fieldMappingService;
        this.integratorService = integratorService;
        this.userService = userService;
        this.toastrService = toastrService;
        this.previewRows = [];
        this.previewColumns = [];
        // Columns that have been picked
        this.mappedFieldNames = [];
        this.isAllFields = false;
        //
        this.isPreview = false;
    }
    JobsFieldMappingComponent.prototype.clickLayer = function (idx) {
        return __awaiter(this, void 0, void 0, function () {
            var currCategory, rsp, err_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.selectedLayer = this.layers[idx];
                        //
                        this.setSampleAddresses();
                        // Update preview
                        this.updatePreview();
                        // if (this.isPreview) {
                        // 	this.openPreview(idx);
                        // }
                        //
                        this.fields = this.selectedLayer.content.fields;
                        currCategory = this.appinfoService.layerTypeList.find(function (d) {
                            return _this.selectedLayer.category === d.name;
                        });
                        // Hide common fields toggle for now
                        this.hasAllFieldsToggle = false;
                        // if (currCategory && currCategory.hasCommon) {
                        // 	this.hasAllFieldsToggle = true;
                        // } else {
                        // 	this.hasAllFieldsToggle = false;
                        // }
                        this.commonFuncService.setLoadingSpinner(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 7, , 8]);
                        if (!(!currCategory.standardCols || !currCategory.standardCols.length)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.fieldMappingService.getStandardSchema(currCategory.id)];
                    case 2:
                        rsp = _a.sent();
                        // currCategory.standardCols = this.fieldMappingService.transformStandardSchema(rsp.data);
                        currCategory.standardCols = rsp;
                        return [4 /*yield*/, this.mapColumns(currCategory)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        this.currStandardCols = currCategory.standardCols;
                        return [4 /*yield*/, this.mapColumns(currCategory)];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        err_1 = _a.sent();
                        console.log(err_1);
                        return [3 /*break*/, 8];
                    case 8:
                        this.commonFuncService.setLoadingSpinner(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    JobsFieldMappingComponent.prototype.removeLayer = function (idx) {
        var layers = this.jobsService.layers.getValue();
        var layer = layers[idx];
        // Remove preview if selected
        if (layer === this.selectedLayer) {
            this.selectedLayer = null;
            this.setSampleAddresses();
            this.previewColumns = [];
            this.previewRows = [];
        }
        this.jobsService.removeRawFilesByLayer(layer);
        layers.splice(idx, 1);
        this.jobsService.layers.next(layers);
    };
    JobsFieldMappingComponent.prototype.mapColumns = function (currCategory) {
        return __awaiter(this, void 0, void 0, function () {
            var mapping;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.currStandardCols = currCategory.standardCols;
                        return [4 /*yield*/, this.fieldMappingService.getSchemaMapping(currCategory.id)];
                    case 1:
                        mapping = _a.sent();
                        this.currStandardCols.forEach(function (c, standardColIdx) {
                            var defaultMapping = mapping.find(function (item) {
                                if (item.standardColumn && c.colName) {
                                    return item.standardColumn.toUpperCase() === c.colName.toUpperCase();
                                }
                            });
                            c.prevMappingCol = defaultMapping ? defaultMapping.layerColumn : null;
                            if (c.matchedCol) {
                                if (_this.fields.indexOf(c.matchedCol) === -1) {
                                    c.matchedCol = '';
                                }
                            }
                            // Note: Do not change 'if' to 'else if' here. The c.matchedCol's value may have changed
                            if (!c.matchedCol) {
                                // Exception for global id: only map to column with name 'globalid'
                                if (c.colName.toLowerCase() === _this.attrIndexService.globalIdColInStandardSchema_lower) {
                                    c.matchedCol = _this.fields.find(function (f) { return f.name && f.name.toLowerCase() === _this.attrIndexService.globalIdColLower; });
                                }
                                else {
                                    var defaultCol_1 = defaultMapping ? defaultMapping.layerColumn : c.colName;
                                    c.matchedCol = _this.fields.find(function (f) {
                                        if (f.name) {
                                            return f.name.toUpperCase() === defaultCol_1.toUpperCase();
                                        }
                                    });
                                    if (!c.matchedCol && c.colName.toLowerCase() === 'nguid') {
                                        c.matchedCol = _this.fields.find(function (f) {
                                            if (f.name) {
                                                return f.name.toLowerCase() === 'site_nguid';
                                            }
                                        });
                                    }
                                }
                                //
                                _this.onSelectColumn(standardColIdx);
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    JobsFieldMappingComponent.prototype.onSelectColumn = function (idx, scrollIntoView) {
        var currStandardCol = this.currStandardCols[idx];
        //
        if (scrollIntoView) {
            this.scrollColumnIntoView(currStandardCol.matchedCol);
        }
        // Set standardCol as matchedStandardCol to selected field
        if (currStandardCol.matchedCol) {
            currStandardCol.matchedCol.matchedStandardCol = currStandardCol;
        }
        var mappedFields = [];
        var repeatedCol;
        this.currStandardCols.forEach(function (c, cIdx) {
            // Update mappedFieldNames
            if (c.matchedCol && c.matchedCol.name) {
                mappedFields.push(c.matchedCol.name);
            }
            // Check if the selected column is already mapped to other standardedCol
            if (cIdx !== idx && c.matchedCol === currStandardCol.matchedCol) {
                repeatedCol = c;
            }
        });
        this.mappedFieldNames = mappedFields;
        // Set previous mapped column to empty
        if (repeatedCol) {
            repeatedCol.matchedCol = '';
        }
        // Set the matchedStandardCol property of previous field that is mapped to this standardCol to empty (If there's any)
        var prevField = this.fields.find(function (f) { return f.matchedStandardCol === currStandardCol && f !== currStandardCol.matchedCol; });
        if (prevField) {
            prevField.matchedStandardCol = null;
        }
    };
    JobsFieldMappingComponent.prototype.saveCurrFieldMapping = function () {
        // TODO
        console.log(this.currStandardCols);
    };
    JobsFieldMappingComponent.prototype.hideField = function (field, col) {
        // Fol GlobalId column, only allow field with same name to map
        if (col.colName.toLowerCase() === this.attrIndexService.globalIdColInStandardSchema_lower) {
            return field.name.toLowerCase() !== this.attrIndexService.globalIdColLower || (field.generalColType !== 'text' && field.generalColType !== 'uuid');
        }
        //
        return col.generalColType && col.generalColType !== 'text' && col.generalColType !== field.generalColType
            && !(col.alterType && col.alterType.toLowerCase() === field.generalColType);
    };
    JobsFieldMappingComponent.prototype.onHoverStandardCol = function (col) {
        this.selectedAddrPart = col.colName.toLowerCase();
        if (col.matchedCol) {
            this.scrollColumnIntoView(col.matchedCol);
        }
    };
    JobsFieldMappingComponent.prototype.onMouseoutStandardCol = function () {
        this.selectedAddrPart = null;
    };
    JobsFieldMappingComponent.prototype.onToggleCommonField = function () {
        this.setSampleAddresses();
    };
    JobsFieldMappingComponent.prototype.updatePreview = function () {
        var _this = this;
        if (!this.selectedLayer) {
            return;
        }
        var previewRows = this.selectedLayer.content.rows;
        if (previewRows.length > 10) {
            this.previewRows = previewRows.slice(0, 10);
        }
        else {
            this.previewRows = previewRows;
        }
        // Add null value if not exist for all columns
        this.previewRows.forEach(function (r) {
            _this.selectedLayer.content.fields.forEach(function (f) {
                if (!r.hasOwnProperty(f.name)) {
                    if (f.isObjectId) {
                        r[f.name] = '';
                    }
                    else {
                        r[f.name] = null;
                    }
                }
            });
        });
        this.previewColumns = this.tableService.setColumnsFromRows(this.previewRows);
        this.previewColumns.forEach(function (col) {
            col.cellClass = function () {
                var c = _this.tableService.fixedCellClassToString(col.info.fixedCellClass);
                if (_this.zoomedColumn && col.prop === _this.zoomedColumn.prop) {
                    c += ' zoomed-column';
                }
                return c;
            };
            col.headerClass = function () {
                if (_this.zoomedColumn && col.prop === _this.zoomedColumn.prop) {
                    return ' zoomed-column-header';
                }
            };
            col.cellTemplate = _this.cellTempl;
        });
        setTimeout(function () {
            if (_this.previewTable) {
                _this.previewTable.resize();
            }
        });
    };
    JobsFieldMappingComponent.prototype.scrollColumnIntoView = function (col) {
        this.zoomedColumn = null;
        if (!col) {
            return;
        }
        var idx = this.previewColumns.findIndex(function (c) { return col.name === c.prop; });
        if (idx <= -1) {
            return;
        }
        this.zoomedColumn = this.previewColumns[idx];
        var colList = this.elemRef.nativeElement.querySelectorAll('datatable-header-cell');
        var scrollLeft = 0;
        for (var i = 0; i < idx; i++) {
            scrollLeft += colList[i].offsetWidth;
        }
        if (scrollLeft > 100) {
            scrollLeft -= 100;
        }
        var tableElem = this.elemRef.nativeElement.querySelector('#preview-content-table datatable-body');
        if (tableElem) {
            tableElem.scrollLeft = scrollLeft;
        }
    };
    JobsFieldMappingComponent.prototype.setSampleAddresses = function () {
        if (!this.selectedLayer || !this.selectedLayer.category || (this.selectedLayer.category !== 'ADDRESS POINTS' && this.selectedLayer.category !== 'ROAD CENTERLINES')) {
            this.sampleAddresses = [];
            return;
        }
        var cate = this.selectedLayer.category;
        var sample = this.appinfoService.sampleAddresses;
        if (!sample || !sample.Common || !sample.Rare) {
            return;
        }
        var addresses = this.isAllFields ? sample.Common.concat(sample.Rare) : sample.Common;
        // Address parts. NOTE: Order Matters!
        var partNames = ['AddNum_Pre', 'Add_Number', 'AddNum_Suf', 'St_PreMod', 'St_PreDir', 'St_PreTyp', 'St_PreSep', 'St_Name', 'St_PosTyp', 'St_PosDir', 'St_PosMod', 'Unit'];
        var formattedAddresses = [];
        addresses.forEach(function (a) {
            var merged;
            if (cate === 'ADDRESS POINTS') {
                merged = Object.assign({}, a.Address_Num, a.Address_Other, a.Road_Name);
            }
            else if (cate === 'ROAD CENTERLINES') {
                merged = a.Road_Name;
            }
            var address = {
                parts: []
            };
            partNames.forEach(function (name) {
                if (merged[name]) {
                    var part = {
                        value: merged[name],
                        partName: name,
                        connectedBy: 'space'
                    };
                    // Rule #1: addnum_Pre & add_number is connected with hyphen
                    if (name === 'AddNum_Pre' && merged['Add_Number']) {
                        part.connectedBy = 'hyphen';
                    }
                    // Rule #2: add_number and addnum_suf doesn't have space
                    else if (name === 'Add_Number' && merged['AddNum_Suf']) {
                        part.connectedBy = false;
                    }
                    address.parts.push(part);
                }
            });
            formattedAddresses.push(address);
        });
        this.sampleAddresses = formattedAddresses;
    };
    // openPreview(idx) {
    // 	this.previewRows = this.layers[idx].content.rows;
    // 	this.previewColumns = this.tableService.setColumnsFromRows(this.previewRows);
    // 	this.isPreview = true;
    // }
    // closePreview() {
    // 	this.previewRows = [];
    // 	this.previewColumns = [];
    // 	this.isPreview = false;
    // }
    ///////////////////////
    // To delete ///////////////////
    // openPreviewDialog(idx) {
    // 	this.previewRows = this.layers[idx].content.rows;
    // 	// const cols: any[] = [];
    // 	// Object.keys(this.previewRows[0]).forEach((c) => {
    // 	// 	cols.push({
    // 	// 		name: c,
    // 	// 		prop: c
    // 	// 	});
    // 	// });
    // 	this.previewColumns = this.tableService.setColumnsFromRows(this.previewRows);
    // 	this.jobsService.openPreviewDialogWindow(
    // 		{
    // 			previewRows: this.previewRows,
    // 			previewColumns: this.previewColumns
    // 		}
    // 	);
    // }
    // Remove empty layers
    JobsFieldMappingComponent.prototype.removeEmptyLayers = function () {
        var layers = this.jobsService.layers.getValue();
        var len = layers.length;
        // Iterate in reverse to keep the correct index while deleting
        while (len--) {
            if (!layers[len].content.rows || !layers[len].content.rows.length) {
                this.jobsService.removeRawFilesByLayer(layers[len]);
                layers.splice(len, 1);
            }
        }
        this.jobsService.layers.next(layers);
    };
    // Check info before uploading
    // 1: NGUID, 2: the columns required by state (insead of NENA) are all mapped or not  3.fishbone
    JobsFieldMappingComponent.prototype.checkNguid = function () {
        return __awaiter(this, void 0, void 0, function () {
            var warnings, sq, _i, _a, key, options, keepUploading, idx;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        warnings = {
                            noNguid: {
                                layers: [],
                                sq: 0
                            },
                            unMapped: {
                                layers: [],
                                sq: 0
                            },
                            unMappedFishbone: {
                                layers: [],
                                sq: 0
                            }
                        };
                        // // Layers that miss NGUID column
                        // const layersN: number[] = [];
                        // const message = 'Without NGUID, the resulting QC report cannot be joined back to your source dataset. Are you sure you want to proceed?';
                        //
                        this.layers.forEach(function (l, idx) { return __awaiter(_this, void 0, void 0, function () {
                            var currLayerType, nguidCol, notMappedStateCols, unMappedFishboneCols;
                            return __generator(this, function (_a) {
                                currLayerType = this.appinfoService.layerTypeList.find(function (d) { return l.category === d.name; });
                                if (currLayerType.standardCols) {
                                    nguidCol = currLayerType.standardCols.find(function (c) { return c.isNguid; });
                                    if (!nguidCol.matchedCol) {
                                        // layersN.push(idx);
                                        warnings.noNguid.layers.push({
                                            index: idx,
                                            name: l.name
                                        });
                                    }
                                    notMappedStateCols = currLayerType.standardCols.filter(function (c) { return c.definedBy !== 'NENA' && !c.matchedCol; });
                                    if (notMappedStateCols.length) {
                                        warnings.unMapped.layers.push({
                                            index: idx,
                                            cols: notMappedStateCols,
                                            name: l.name
                                        });
                                    }
                                    unMappedFishboneCols = currLayerType.standardCols.filter(function (c) { return c.isFishboneCol && !c.matchedCol; });
                                    if (unMappedFishboneCols.length) {
                                        warnings.unMappedFishbone.layers.push({
                                            index: idx,
                                            cols: unMappedFishboneCols,
                                            name: l.name
                                        });
                                    }
                                }
                                return [2 /*return*/];
                            });
                        }); });
                        sq = 0;
                        for (_i = 0, _a = Object.keys(warnings); _i < _a.length; _i++) {
                            key = _a[_i];
                            if (warnings[key].layers.length) {
                                sq++;
                                warnings[key].sq = sq;
                            }
                        }
                        if (!(warnings.noNguid.layers.length || warnings.unMapped.layers.length)) return [3 /*break*/, 2];
                        options = {
                            data: warnings
                        };
                        return [4 /*yield*/, this.modalService.openModalWindow(ModalCheckMappingComponent, options)];
                    case 1:
                        keepUploading = _b.sent();
                        if (!keepUploading) {
                            idx = warnings.noNguid.layers[0] ? warnings.noNguid.layers[0].index : warnings.unMapped.layers[0].index;
                            this.clickLayer(idx);
                        }
                        return [2 /*return*/, keepUploading];
                    case 2: return [2 /*return*/, true];
                }
            });
        });
    };
    JobsFieldMappingComponent.prototype.goNext = function (withQC) {
        return __awaiter(this, void 0, void 0, function () {
            var unmappedSchema, missingGlobalId, missingDiscrepancy, keepUploading, longTransactionExist, rsp, err_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        unmappedSchema = [];
                        missingGlobalId = [];
                        missingDiscrepancy = [];
                        this.layers.forEach(function (l) {
                            var currLayerType = _this.appinfoService.layerTypeList.find(function (d) { return l.category === d.name; });
                            if (currLayerType.standardCols) {
                                var isMatchCol = currLayerType.standardCols.some(function (c) { return c.matchedCol; });
                                // isLayersMap.push(isMatchCol);
                                if (!isMatchCol) {
                                    unmappedSchema.push(currLayerType.name);
                                    return;
                                }
                                // Check global id
                                var globalIdCol = currLayerType.standardCols.find(function (c) { return c.colName.toLowerCase() === _this.attrIndexService.globalIdColInStandardSchema_lower; });
                                if (!globalIdCol || !globalIdCol.matchedCol) {
                                    missingGlobalId.push(currLayerType.name);
                                    return;
                                }
                                // Check discrepancy agency for collaborative layer
                                if (currLayerType.isCollaborative) {
                                    var discrepancyAgencyCol = currLayerType.standardCols.find(function (c) { return c.colName.toLowerCase() === _this.attrIndexService.discrepancyAgencyIdStandardLower; });
                                    if (!discrepancyAgencyCol || !discrepancyAgencyCol.matchedCol) {
                                        missingDiscrepancy.push(currLayerType.name);
                                    }
                                }
                            }
                            else {
                                // isLayersMap.push(false);
                                unmappedSchema.push(currLayerType.name);
                            }
                        });
                        // TODO. Relax globalId rule for now
                        // if (missingGlobalId.length) {
                        // 	this.toastrService.warning('Missing Global ID column: ' + missingGlobalId.join(', '))
                        // 	return;
                        // }
                        if (unmappedSchema.length) {
                            this.toastrService.warning('Unmapped Schema Found: ' + unmappedSchema);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.checkNguid()];
                    case 1:
                        keepUploading = _a.sent();
                        if (!keepUploading) {
                            return [2 /*return*/];
                        }
                        this.commonFuncService.setLoadingSpinner(true);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 7, , 8]);
                        // Remove empty layers before uploading
                        this.removeEmptyLayers();
                        return [4 /*yield*/, this.adminService.checkLongTransactions()];
                    case 3:
                        longTransactionExist = _a.sent();
                        if (!!longTransactionExist) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.jobsService.uploadFiles('ALL')];
                    case 4:
                        rsp = _a.sent();
                        this.commonFuncService.setLoadingSpinner(false);
                        return [4 /*yield*/, this.router.navigate(['azgiv/dashboard'])];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        err_2 = _a.sent();
                        this.commonFuncService.setLoadingSpinner(false);
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    JobsFieldMappingComponent.prototype.goPrev = function () {
        this.router.navigate(['azgiv/jobs/add-files']);
        // this.stateService.go('jobsfilesadd');
    };
    JobsFieldMappingComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    JobsFieldMappingComponent.prototype.ngAfterViewInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var selectedCustomerId_1, customer;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        //
                        this.layersSub = this.jobsService.layers.subscribe(function (layers) {
                            _this.layers = layers;
                        });
                        if (!(this.userService.customerInfo.type === 'integrator')) return [3 /*break*/, 3];
                        if (!!this.userService.clients) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.integratorService.getIntegratorClients()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        selectedCustomerId_1 = this.userService.selectedCustomer.getValue() ? this.userService.selectedCustomer.getValue().id : null;
                        customer = this.userService.clients.find(function (c) { return c.cusId === selectedCustomerId_1; });
                        if (customer) {
                            this.agencyName = customer.cusNameShort;
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        this.agencyName = this.userService.getUserInfo().customerName;
                        _a.label = 4;
                    case 4:
                        // Default: get first layer mapping
                        if (this.layers.length) {
                            this.clickLayer(0);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    JobsFieldMappingComponent.prototype.ngOnDestroy = function () {
        this.layersSub.unsubscribe();
    };
    return JobsFieldMappingComponent;
}());
export { JobsFieldMappingComponent };
